import React from "react"
import Icon from "../icon"
import { useField, useFormContext } from "../use-form"

export type InlineValidationProps = {
  /** The field name to display validation errors for (must match a field name in the parent Form) */
  name: string
}

/**
 * Displays inline validation errors for a form field.
 * Requires a parent Form with `validation` enabled, and the field must be touched with an error set.
 */
function InlineValidation({ name }: InlineValidationProps) {
  const context = useFormContext()
  const config = context?.config || {}
  const field = useField({ name })

  // To support previous behavior of the validation errors all in one place
  // on the form, we won't show this unless opted in to the new behavior.
  if (!config.validation) return null
  if (!field.touched) return null
  if (!field.error) return null

  return (
    <div className="text-xs" style={{ height: "17px" }} role="alert">
      <Icon name="alert-circle" size="xs" className="text-red-500 mr-1" alt="" />
      {field.error}
    </div>
  )
}

export { InlineValidation }
export default InlineValidation
